<script lang="ts">
  import type { IntegrationDetails } from "../../helpers/types";

  export let integrations: IntegrationDetails[];
</script>

<div class="empty-container">
  {#if integrations?.length}
    <img class="empty_img" alt="empty_state" src="static/assets/icons/hug2.svg" />
    <h1>manage integrations</h1>
    <h2 class="subtitle">
      {integrations?.length == 1
        ? " select an integration to manage or add more"
        : "select an integration to manage"}
    </h2>
  {:else}
    <img class="empty_img" alt="empty_state" src="static/assets/icons/hug.svg" />
    <h1>no integrations yet</h1>
    <h2 class="subtitle">select your software from the list</h2>
  {/if}
</div>

<style>
  .empty-container {
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .subtitle {
    color: var(--rekki-neutral-03);
    font-weight: normal;
  }
</style>
